import { defineStore } from 'pinia';
import { type IStrapiImage } from '~/types/strapiImage';
import { assignDataToFields, createPopulateString } from '~/utils/strapiComponents/addStrapiData';
import { useStoreRoot } from '../abstract/root';
import { strapi } from '../transport/strapi';
import type { IImageLink, ILink } from '~/types/links';
import type { EGeo } from '~/types/seoHead';

export const useStoreFooter = defineStore('footer', {
  state: () => ({
    logo: {} as IStrapiImage,
    partnersLogo: {} as IStrapiImage,
    promotionsTitle: '',
    promotionsLink: [] as ILink[],
    informationTitle: '',
    informationLink: [] as ILink[],
    gamesTitle: '',
    gamesLink: [] as ILink[],
    helpTitle: '',
    helpLink: [] as ILink[],
    worldwideTitle: '',
    worldwideLink: [] as ILink[],
    europeTitle: '',
    europeLink: [] as ILink[],
    blogTitle: '',
    blogLink: [] as ILink[],
    gamesSuppliedTitle: '',
    gamesSuppliedLink: [] as IImageLink[],
    paymentMethodsTitle: '',
    paymentMethodsLink: [] as IImageLink[],
    blockAwardsTitle: '',
    blockAwardsLink: [] as IImageLink[],
    partnersTitle: '',
    partnersLink: [] as IImageLink[],
    gamblers: [] as IImageLink[],
    responsibleGamingTitle: '',
    responsibleGamingLink: {} as ILink,
    copyright: '',
    licenseText: '',
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadFooter(force?: boolean) {
      if (!force && this.copyright.length) {
        return true;
      }

      if (!this.requestPromise) {
        const populateString = createPopulateString([
          'logo',
          'informationLink',
          'promotionsLink',
          'gamesLink',
          'helpLink',
          'worldwideLink',
          'europeLink',
          'blogLink',
          'responsibleGamingLink',
          'gamesSuppliedLink',
          'gamesSuppliedLink.img_src',
          'paymentMethodsLink',
          'paymentMethodsLink.img_src',
          'blockAwardsLink',
          'blockAwardsLink.img_src',
          'partnersLink',
          'partnersLink.img_src',
          'gamblers',
          'gamblers.img_src',
          'partnersLogo',
          'mirrorFooter',
        ]);

        this.requestPromise = strapi()
          .get('footer', populateString)
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        const geo = useStoreRoot().geo;

        if (geo && geo !== 'main') {
          const mirrorFooter = response.data.mirrorFooter?.find(
            (h: { geo?: EGeo; licenseText?: string }) => h?.geo === geo
          );

          if (mirrorFooter) {
            this.licenseText = mirrorFooter.licenseText || '';
          }

          this.partnersLink = this.partnersLink.map((link) => ({ ...link, jsLink: true }));
          this.gamesSuppliedLink = this.gamesSuppliedLink.map((link) => ({
            ...link,
            jsLink: true,
          }));
        }

        return true;
      } else {
        return false;
      }
    },
  },
});
